import {
  getDepartmentNamesArray,
  getItemOrDefaultToValue,
  getPersonName,
} from '../../details';
import { setAssetName } from 'utils/helper/task';
import assetCategories from 'static/asset_categories.json';

export const transform = (list, globalDepartmentList = []) => {
  const addIconToAssetList = list.map(asset => {
    const icon = assetCategories?.find(f => f.id === asset?.type?.category);
    return {
      ...asset,
      type: {
        ...asset.type,
        categoryIcon: icon ? icon.icon : '',
      },
    };
  });
  return addIconToAssetList.map(data => ({
    id: data.id,
    archived: data.archived,
    assetId: getItemOrDefaultToValue(data, 'assetId', '-'),
    assetName: data.name,
    typeId: getItemOrDefaultToValue(data.type, 'id', '-'),
    category: {
      id: getItemOrDefaultToValue(data.type, 'category', '-'),
      icon: getItemOrDefaultToValue(data.type, 'categoryIcon', '-'),
      name: getItemOrDefaultToValue(data.type, 'category', '-'),
    },
    name: setAssetName(data),
    typeName: typeNameConstructor(data.type.name, data.type.assetTypeId),
    originalTypeName: data.type.name,
    assignedTo: data.currentAssignee
      ? getPersonName(data.currentAssignee.general)
      : '-',
    currentAssigneeId: data.currentAssignee
      ? data.currentAssignee.general.id
      : null,
    handoverRequired: getItemOrDefaultToValue(
      data.type,
      'handoverRequired',
      '-',
    ),
    qualificationRequired: getItemOrDefaultToValue(
      data.type,
      'qualificationRequired',
      '-',
    ),
    status: getItemOrDefaultToValue(data, 'currentStatus', '-'),
    departments:
      data?.departmentIds && globalDepartmentList.length > 0
        ? getDepartmentNamesArray(globalDepartmentList, data)
        : [],
  }));
};

export const transformAssetList = list => {
  return list.map(item => ({
    id: item.id,
    name: setAssetName(item),
  }));
};

export const typeNameConstructor = (typeName, typeId) => {
  if (typeId) {
    return `${typeName} (${typeId})`;
  } else if (!typeId) {
    return typeName;
  } else return '-';
};
